import {Directive, Input} from '@angular/core';

@Directive({
    selector: 'tfl-url-based-filter,tfl-callback-based-filter'
})
export class FilterDirective {
    @Input('columns') columns: number = 3;
    @Input('verticalAlignment') verticalAlignment: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/container/filter.directive.ts